import type { IRegisteredContract } from './IRegisteredContract';
import { RegisteredContractLine } from './RegisteredContractLine';

export class RegisteredContract implements IRegisteredContract {
    byggNummer: IRegisteredContract['byggNummer'];
    endDate?: IRegisteredContract['endDate'];
    kontraktLinjeNavn: IRegisteredContract['kontraktLinjeNavn'];
    kontraktNavn: IRegisteredContract['kontraktNavn'];
    kontraktNummer: IRegisteredContract['kontraktNummer'];
    kundeNavn: IRegisteredContract['kundeNavn'];
    kundeNummer: IRegisteredContract['kundeNummer'];
    startDate?: IRegisteredContract['startDate'];
    linjer: IRegisteredContract['linjer'];

    public static empty() {
        return RegisteredContract.parseObject({
            byggNummer: '',
            endDate: new Date(),
            kontraktLinjeNavn: '',
            kontraktNavn: '',
            kontraktNummer: '',
            kundeNavn: '',
            kundeNummer: '',
            startDate: new Date(),
            linjer: [],
        });
    }

    constructor(props: IRegisteredContract) {
        Object.assign(this, props);
        this.linjer = RegisteredContractLine.parseArray(
            this.kontraktNummer,
            this.linjer,
        );
    }

    public static parseObject(obj: IRegisteredContract): RegisteredContract {
        try {
            return new RegisteredContract(obj);
        } catch (error) {
            throw new Error(
                `Could not parse Contract Registration object : ${JSON.stringify(
                    obj,
                )}`,
            );
        }
    }

    public static parseArray(
        kontrakter: Array<IRegisteredContract>,
    ): Array<IRegisteredContract> {
        const result: Array<IRegisteredContract> = [];
        kontrakter.map((item) => {
            result.push(RegisteredContract.parseObject(item));
        });

        return result;
    }
}
